import axios from 'axios';
import config from '../config.js';

export const API_URL = config['api_url'];
export const STORAGE_URL = config['Storagebase_url'];

axios.defaults.baseURL = API_URL;

//auth reducer
export const LOGIN_SUCCESS_ACTION = 'login_success';
export const LOGIN_FAILURE_ACTION = 'login_failure';
export const LOGOUT_SUCCESS_ACTION = 'logout_sucess';
export const LOGOUT_FAILURE_ACTION = 'logout_failure';
export const SET_EMAIL = 'set_email';

// template comparision
export const COMPARE_TEMPLATE_COLUMNS_SUCCESS = "COMPARE_TEMPLATE_COLUMNS_SUCCESS";
export const COMPARE_TEMPLATE_COLUMNS_FAILURE = "COMPARE_TEMPLATE_COLUMNS_FAILURE";

//Users reducer
export const USERLIST_SUCCESS_ACTION = 'userlist_success';
export const USERLIST_FAILURE_ACTION = 'userlist_failure';
export const ADD_USER_SUCCESS_ACTION = 'add_user_success';
export const ADD_USER_FAILURE_ACTION = 'add_user_failure';
export const EDIT_USER_SUCCESS_ACTION = 'edit_user_success';
export const EDIT_USER_FAILURE_ACTION = 'edit_user_failure';
export const DELETE_USER_SUCCESS_ACTION = 'delete_user_success';
export const DELETE_USER_FAILURE_ACTION = 'delete_user_failure';

export const UPLOAD_MASTER_FILE_SUCCESS = "UPLOAD_MASTER_FILE_SUCCESS";
export const UPLOAD_MASTER_FILE_FAILURE = "UPLOAD_MASTER_FILE_FAILURE";
export const SAVE_UPLOADED_FILE_SUCCESS_ACTION = "SAVE_UPLOADED_FILE_SUCCESS_ACTION";
export const SAVE_UPLOADED_FILE_FAILURE_ACTION = "SAVE_UPLOADED_FILE_FAILURE_ACTION";
export const GET_TEMPLATES_SUCCESS_ACTION = "GET_TEMPLATES_SUCCESS_ACTION";
export const GET_TEMPLATES_FAILURE_ACTION = "GET_TEMPLATES_FAILURE_ACTION";
export const GET_MASTER_DATA_SUCCESS_ACTION = "GET_MASTER_DATA_SUCCESS_ACTION";
export const GET_MASTER_DATA_FAILURE_ACTION = "GET_MASTER_DATA_FAILURE_ACTION";
export const GET_FILTER_MASTER_DATA_SUCCESS_ACTION = "GET_FILTER_MASTER_DATA_SUCCESS_ACTION";
export const GET_FILTER_MASTER_DATA_FAILURE_ACTION = "GET_FILTER_MASTER_DATA_FAILURE_ACTION";

export const SAVE_UPLOADED_MASTER_FILE_SUCCESS_ACTION = "SAVE_UPLOADED_MASTER_FILE_SUCCESS_ACTION";
export const SAVE_UPLOADED_MASTER_FILE_FAILURE_ACTION = "SAVE_UPLOADED_MASTER_FILE_FAILURE_ACTION";
export const GET_DASHBOARD_DATA_SUCCESS_ACTION = "GET_DASHBOARD_DATA_SUCCESS_ACTION";
export const GET_DASHBOARD_DATA_FAILURE_ACTION = "GET_DASHBOARD_DATA_FAILURE_ACTION";
export const DELETE_FILE_SUCCESS_ACTION = "DELETE_FILE_SUCCESS_ACTION";
export const DELETE_FILE_FAILURE_ACTION = "DELETE_FILE_FAILURE_ACTION";
export const UPDATE_FILE_NAME_SUCCESS_ACTION = "UPDATE_FILE_NAME_SUCCESS_ACTION";
export const UPDATE_FILE_NAME_FAILURE_ACTION = "UPDATE_FILE_NAME_FAILURE_ACTION";

export const RAW_FILE_PROCESS_SUCCESS_ACTION = "RAW_FILE_PROCESS_SUCCESS_ACTION";
export const RAW_FILE_PROCESS_FAILURE_ACTION = "RAW_FILE_PROCESS_FAILURE_ACTION";
export const GET_RAW_FILES_DATA_SUCCESS_ACTION = "GET_RAW_FILES_DATA_SUCCESS_ACTION";
export const GET_RAW_FILES_DATA_FAILURE_ACTION = "GET_RAW_FILES_DATA_FAILURE_ACTION";
export const GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION = "GET_AUTOMATION_STATUS_DATA_SUCCESS_ACTION";
export const GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION = "GET_AUTOMATION_STATUS_DATA_FAILURE_ACTION";
export const SEND_FEEDBACK_MAIL_SUCCESS_ACTION = "SEND_FEEDBACK_MAIL_SUCCESS_ACTION";
export const SEND_FEEDBACK_MAIL_FAILURE_ACTION = "SEND_FEEDBACK_MAIL_FAILURE_ACTION";
export const REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION = "REPORT_DISBURSEMENT_DATA_SUCCESS_ACTION";
export const REPORT_DISBURSEMENT_DATA_FAILURE_ACTION = "REPORT_DISBURSEMENT_DATA_FAILURE_ACTION";
export const SEND_VERIFICATION_CODE_MAIL_SUCCESS_ACTION = "SEND_VERIFICATION_CODE_MAIL_SUCCESS_ACTION";
export const SEND_VERIFICATION_CODE_MAIL_FAILURE_ACTION = "SEND_VERIFICATION_CODE_MAIL_FAILURE_ACTION";
export const VERIFY_VERIFICATION_CODE_MAIL_SUCCESS_ACTION = "VERIFY_VERIFICATION_CODE_MAIL_SUCCESS_ACTION";
export const VERIFY_VERIFICATION_CODE_MAIL_FAILURE_ACTION = "VERIFY_VERIFICATION_CODE_MAIL_FAILURE_ACTION";
export const DISBURSEMENT_FORMULAS_DATA_SUCCESS_ACTION = "DISBURSEMENT_FORMULAS_DATA_SUCCESS_ACTION";
export const DISBURSEMENT_FORMULAS_DATA_FAILURE_ACTION = "DISBURSEMENT_FORMULAS_DATA_FAILURE_ACTION";
export const DISBURSEMENT_UPDATE_FORMULAS_DATA_SUCCESS_ACTION = "DISBURSEMENT_UPDATE_FORMULAS_DATA_SUCCESS_ACTION";
export const DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION = "DISBURSEMENT_UPDATE_FORMULAS_DATA_FAILURE_ACTION";
export const DISBURSEMENT_DELETE_DATA_SUCCESS_ACTION = "DISBURSEMENT_DELETE_DATA_SUCCESS_ACTION";
export const DISBURSEMENT_DELETE_DATA_FAILURE_ACTION = "DISBURSEMENT_DELETE_DATA_FAILURE_ACTION";
export const GET_DOWNLOAD_WORKINGFILES_SUCCESS_ACTION = "GET_DOWNLOAD_WORKINGFILES_SUCCESS_ACTION";
export const GET_DOWNLOAD_WORKINGFILES_FAILURE_ACTION = "GET_DOWNLOAD_WORKINGFILES_FAILURE_ACTION";

//File Download Actions
export const DOWNLOAD_SELECTED_FILES_SUCCESS_ACTION = "DOWNLOAD_SELECTED_FILES_SUCCESS_ACTION";
export const DOWNLOAD_SELECTED_FILES_FAILURE_ACTION = "DOWNLOAD_SELECTED_FILES_FAILURE_ACTION";

export const DOWNLOAD_ALL_DISTRIBUTORS_SUCCESS_ACTION = "DOWNLOAD_ALL_DISTRIBUTORS_SUCCESS_ACTION";
export const DOWNLOAD_ALL_DISTRIBUTORS_FAILURE_ACTION = "DOWNLOAD_ALL_DISTRIBUTORS_FAILURE_ACTION";

export const CLONE_MONTHLY_TEMPLATE_SUCCESS_ACTION = "CLONE_MONTHLY_TEMPLATE_SUCCESS_ACTION";
export const CLONE_MONTHLY_TEMPLATE_FAILURE_ACTION = "CLONE_MONTHLY_TEMPLATE_FAILURE_ACTION";

export const IMPORT_FILE_TEMPLATES_SUCCESS = "IMPORT_FILE_TEMPLATES_SUCCESS";
export const IMPORT_FILE_TEMPLATES_FAILURE = "IMPORT_FILE_TEMPLATES_FAILURE";

